var _path, _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2AFlips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a2a-flips-icon",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 56.0498C59 56.8321 58.689 57.5825 58.1357 58.1357C57.5824 58.689 56.8321 59 56.0498 59H2.9502C2.1679 59 1.41752 58.689 0.864258 58.1357C0.310991 57.5825 0 56.8321 0 56.0498V17.7002H59V56.0498ZM4.82617 41.1689C4.15078 40.7244 3.67652 41.4773 4.27051 41.9883C10.9333 48.217 19.669 52 29.4883 52C36.429 52 44.3999 49.6947 50.1191 45.4062C50.5525 45.0858 50.6364 44.734 50.374 44.3477C49.8257 43.5431 48.8823 44.2651 47.9873 44.6357C42.0845 46.9786 36.1025 48.1514 30.0469 48.1514C20.9591 48.1514 12.5522 45.8228 4.82617 41.1689ZM52.2988 40.0635C51.3119 39.836 48.9894 40.2723 47.9873 40.5449C47.378 40.7088 46.1294 41.512 45.4375 42.1816C45.1784 42.7213 47.3854 42.2584 47.9873 42.1816C52.6509 41.7605 54.0612 41.5573 50.9072 49.2578C50.7722 49.6336 50.9708 49.835 51.2334 49.835C52.0927 49.835 53.753 46.8794 54.1074 45.958C54.5103 44.912 55.3916 41.703 54.8027 40.7871C54.5247 40.435 53.6886 40.1933 52.2988 40.0635ZM51.2773 0C51.8249 0.000360757 52.3613 0.153336 52.8271 0.441406C53.2927 0.72945 53.6693 1.14117 53.9141 1.63086L59 11.7998H0L5.08594 1.63086C5.33074 1.14117 5.7072 0.729451 6.17285 0.441406C6.63864 0.153337 7.17506 0.000368269 7.72266 0H51.2773Z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #a2a-flips-icon path {\n            fill: url(#bg);\n        }\n        .dark #a2a-flips-icon path {\n            fill: url(#bg-dark);\n        }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 30.5) rotate(90) scale(30.5 31.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D8FFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-dark",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29 26) rotate(87.546) scale(35.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2AFlips);
export default __webpack_public_path__ + "static/media/a2a-flips.79a0f1e65500c60d077ea78923a7af7c.svg";
export { ForwardRef as ReactComponent };